<template>
  <div class="textTit">
    <span class="tip"></span>
    <div class="text">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: "TitTip",
  props: {
    title: {
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.textTit {
  display: flex;
  align-items: center;
  padding: 6px 0;
  .tip {
    width: 3px;
    height: 16px;
    background: rgb(58, 117, 197);
    margin: 0 8px;
  }
  .text {
    font-size: 14px;
    color: #000;
  }
}
</style>